<template>
<div class="column-div">
  <h1>
    <img style="cursor: pointer;" src="./img/back.svg" @click="$emit('back')" alt="back">
    Stats
  </h1>
  <div>
    <button @click="getAllAsk">Get All Questions Asked</button>
    <button @click="getGoodAsk">Get Good Questions Asked</button>
    <button @click="$emit('back')">Back</button>
    <button @click="print()">Print</button>
  </div>
  <div>
    <!-- {{ goodOnes }} -->
    <ul>
      <li :key="goodOnes.senderUUID + 'ppo'" v-for="goodOnes in sortedGoodQuestions()">
        Name: {{ goodOnes.name }}, Star Count: {{ goodOnes.count }}
        <br />
        <ul>
          <li>Questions Asked:</li>
          <ol>
            <li :key="msg._id + 'msg'" v-for="msg in goodOnes.messages">
              <span v-if="msg.type === 'text'">
                {{ msg.text }}
              </span>
              <span v-if="msg.type === 'img'">
                <img class="image" :src="msg.imgURL">
              </span>
            </li>
          </ol>
        </ul>
      </li>
    </ul>

  </div>
</div>
</template>

<script>
import { API } from '@/yoteach2-gui/parts/index.js'
import _ from 'lodash'

export default {
  props: {
    roomID: {},
    roomAdminPassword: {}
  },
  data () {
    return {
      goodOnes: []
    }
  },
  computed: {
    countByDeviceID () {
      return _.countBy(this.goodOnes, 'senderUUID')
    },
    groupByDeviceID () {
      return _.groupBy(this.goodOnes, 'senderUUID')
    }
  },
  mounted () {
    this.getGoodAsk()
  },
  methods: {
    print () {
      window.print()
    },
    getAllAsk () {
      API.getAllAsk({ roomID: this.roomID, roomAdminPassword: this.roomAdminPassword })
        .then((resp) => {
          this.goodOnes = resp.data
        })
    },
    getGoodAsk () {
      API.getGoodAsk({ roomID: this.roomID, roomAdminPassword: this.roomAdminPassword })
        .then((resp) => {
          this.goodOnes = resp.data
        })
    },
    sortedGoodQuestions () {
      return Object.keys(this.groupByDeviceID).map((keyOfDeviceGroup, key) => {
        return {
          senderUUID: keyOfDeviceGroup,
          name: this.getNameFromDeviceID(keyOfDeviceGroup),
          count: this.countByDeviceID[keyOfDeviceGroup],
          messages: this.groupByDeviceID[keyOfDeviceGroup]
        }
      }).sort((a, b) => {
        if (a.count < b.count) {
          return 1
        } else if (a.count === b.count) {
          return 0
        } else {
          return -1
        }
      })
    },
    getNameFromDeviceID (senderUUID) {
      return this.goodOnes.find((msg) => { return msg.senderUUID === senderUUID }).senderName
    },
    download () {
      window.print()
    }
  }
}
</script>

<style scoped>
.image{
  height: 100px;
}
.column-div{
  width: 80%;
  margin: 0px auto;
}
</style>
